export const posaleVersions = {
  getCampaignOffers: 'mock',
};
